export const SCHEME_TYPE = {
    DETAIL: 'detail'
};

const fnMap = {
    [SCHEME_TYPE.DETAIL]: ({ stockId }) => `ftnn://quote/stockDetail/${stockId}/1`
};

export const getSchemeLink = (stockId) => {
    return fnMap[SCHEME_TYPE.DETAIL]({ stockId }) || '';
};
